export default function zipcode(str: string) {
    str = str.replace(/[^\d]/g, '');
    const matched = str.match(/\d{1,5}-?(\d{1,4})?/g);

    if (matched && matched.length > 0) {
        if (matched[0].length <= 5) {
            str = matched[0];
        } else {
            str = matched[0].substring(0, 5) + '-' + matched[0].substring(5, 9);
        }
    }

    return str;
}
